import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-secondary50 text-left" }, "Histórico de aprovação de trocas", -1)
const _hoisted_2 = { class: "w-full pb-4" }
const _hoisted_3 = {
  key: 0,
  class: "w-full overflow-x-auto border border-[#d8d8e2] rounded-lg"
}
const _hoisted_4 = { class: "w-full min-w-[1085px] table-fixed border-collapse" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "shrink-0 w-10 h-10 rounded-full bg-slate-200" }),
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-1" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-28 bg-slate-200 rounded" }),
      /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-16 bg-slate-200 rounded" })
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-24 bg-slate-200 rounded" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-32 bg-slate-200 rounded" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-6 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-20 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-6 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-24 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-20 bg-slate-200 rounded-full" })
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-8 w-20 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_14 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "w-full overflow-x-auto border border-[#d8d8e2] rounded-lg"
}
const _hoisted_16 = { class: "w-full min-w-[1085px] table-fixed border-collapse" }
const _hoisted_17 = { class: "px-3 py-3" }
const _hoisted_18 = {
  class: "flex items-center gap-2",
  "data-testid": "history-transfer-cell"
}
const _hoisted_19 = { class: "min-w-0 flex-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "block mb-0.5 text-[11px] font-bold uppercase text-[#7f7f8e]" }, " Passou ", -1)
const _hoisted_21 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "shrink-0 w-5 h-5 text-primary",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_22 = ["d"]
const _hoisted_23 = { class: "min-w-0 flex-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "block mb-0.5 text-[11px] font-bold uppercase text-[#7f7f8e]" }, " Recebeu ", -1)
const _hoisted_25 = {
  key: 1,
  class: "block text-[13px] text-left text-[#7f7f8e] truncate",
  "data-testid": "history-transfer-empty-receiver"
}
const _hoisted_26 = { class: "px-3 py-3" }
const _hoisted_27 = { class: "block text-[13px] text-[#16161d] text-left truncate" }
const _hoisted_28 = { class: "px-3 py-3" }
const _hoisted_29 = { class: "flex flex-col gap-0.5 overflow-hidden" }
const _hoisted_30 = { class: "text-[13px] font-bold text-left text-[#16161d] truncate" }
const _hoisted_31 = {
  key: 0,
  class: "text-[12px] text-left text-[#7f7f8e]"
}
const _hoisted_32 = { class: "px-3 py-3 text-center" }
const _hoisted_33 = { class: "text-[13px] text-[#16161d]" }
const _hoisted_34 = { class: "px-3 py-3 text-center" }
const _hoisted_35 = { class: "text-[13px] text-[#16161d]" }
const _hoisted_36 = { class: "px-3 py-3 text-center" }
const _hoisted_37 = { class: "text-[13px] text-[#16161d]" }
const _hoisted_38 = { class: "px-3 py-3 text-center" }
const _hoisted_39 = { class: "block text-[13px] text-[#16161d] truncate" }
const _hoisted_40 = { class: "px-3 py-3 text-center" }
const _hoisted_41 = { class: "flex justify-center" }
const _hoisted_42 = { class: "px-3 py-3 text-center" }
const _hoisted_43 = {
  key: 2,
  class: "flex items-center justify-center py-12 text-sm text-[#7f7f8e]"
}
const _hoisted_44 = { class: "flex justify-center" }

import { computed, ref, watch } from 'vue'
import { format, parseISO } from 'date-fns'
import { mdiArrowRight } from '@mdi/js'
import { storeToRefs } from 'pinia'
import { useHandoverStore } from '@/pinia-store/useHandoverStore'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'
import type { AdminQueueResponse } from '@/Network/Types/Responses/HandoverInviteResponses'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import DoctorInfo from '@/components/DoctorInfo.vue'
import HandoverHistoryDetailModal from './HandoverHistoryDetailModal.vue'
import HandoverStatusBadge from './HandoverStatusBadge.vue'
import HandoverFilters from './HandoverFilters.vue'
import { resolveTransferReceiver, resolveEmptyReceiverLabel } from './handoverTransfer'
import type { HandoverFilterValues } from './handoverFilters.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'HandoverHistoryModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;





const handoverStore = useHandoverStore()
const { history, isLoadingHistory, historyMeta } = storeToRefs(handoverStore)

const showDetailModal = ref(false)
const selectedItem = ref<AdminQueueResponse | null>(null)

const handleDetail = (item: AdminQueueResponse) => {
  selectedItem.value = item
  showDetailModal.value = true
}

function handleChangePage(page: number) {
  handoverStore.fetchHistory(page)
}

const applyHistoryFilters = (filters: HandoverFilterValues) => {
  handoverStore.setHistoryFilters(filters)
  handoverStore.fetchHistory(1)
}

// Larguras somam 1085px (< 1200px do modal, já descontando o padding do corpo)
// para caber sem scroll horizontal a partir de 1280px de viewport.
const columns = [
  { key: 'transfer', label: 'Troca', width: 'w-[300px]' },
  { key: 'schedule', label: 'Escala', width: 'w-[110px]' },
  { key: 'healthUnit', label: 'Unidade', width: 'w-[110px]' },
  { key: 'candidates', label: 'Profissionais que querem assumir', width: 'w-[90px]' },
  { key: 'inviteDate', label: 'Data do convite', width: 'w-[95px]' },
  { key: 'shifts', label: 'Plantões', width: 'w-[70px]' },
  { key: 'sponsor', label: 'Avaliador', width: 'w-[100px]' },
  { key: 'status', label: 'Status', width: 'w-[110px]' },
  { key: 'actions', label: 'Ações', width: 'w-[100px]' }
]

// Resolver o receptor uma vez por linha, e não a cada expressão do template.
const rows = computed(() =>
  history.value.map((item) => ({
    item,
    receiver: resolveTransferReceiver(item),
    emptyReceiverLabel: resolveEmptyReceiverLabel(item)
  }))
)

// Um convite pode agrupar plantões de unidades diferentes — exibimos a primeira
// e sinalizamos as demais com um contador.
const getHealthUnitNames = (item: AdminQueueResponse) => {
  const names = item.package.stations
    .map((station) => station.healthUnit?.name)
    .filter((name): name is string => !!name)
  return [...new Set(names)]
}

const formatDate = (dateStr: string) => {
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy')
  } catch {
    return dateStr
  }
}

watch(
  () => props.modelValue,
  (isOpen) => {
    if (isOpen) {
      handoverStore.resetHistoryFilters()
      handoverStore.fetchHistory(1)
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalVue, {
      "modal-active": _ctx.modelValue,
      "max-width": "max-w-[1200px]",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_44, [
          _createVNode(FilledButton, {
            text: "Fechar",
            width: "100%",
            height: "48px",
            class: "bg-primary30",
            "data-testid": "history-close-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(HandoverFilters, {
            "model-value": _unref(handoverStore).historyFilters,
            context: "history",
            "onUpdate:modelValue": applyHistoryFilters
          }, null, 8, ["model-value"])
        ]),
        (_unref(isLoadingHistory))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
                      return _createElementVNode("th", {
                        key: col.key,
                        class: _normalizeClass(["bg-[#f0f0f4] px-3 py-2.5 text-[13px] font-bold text-[#272735] text-center leading-tight align-middle", col.width])
                      }, _toDisplayString(col.label), 3)
                    }), 64))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                    return _createElementVNode("tr", {
                      key: n,
                      class: "border-t border-[#d8d8e2] bg-white animate-pulse"
                    }, _hoisted_14)
                  }), 64))
                ])
              ])
            ]))
          : (_unref(history).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("table", _hoisted_16, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
                        return _createElementVNode("th", {
                          key: col.key,
                          class: _normalizeClass(["bg-[#f0f0f4] px-3 py-2.5 text-[13px] font-bold text-[#272735] text-center leading-tight align-middle", col.width])
                        }, _toDisplayString(col.label), 3)
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, ({ item, receiver, emptyReceiverLabel }) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.package.id,
                        class: "border-t border-[#d8d8e2] bg-white"
                      }, [
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createVNode(DoctorInfo, {
                                name: item.package.requester.name,
                                subtitle: `CRM ${item.package.requester.crm}`,
                                "avatar-url": item.package.requester.avatarUrl,
                                "nps-score": item.package.requester.npsScore,
                                size: "sm",
                                truncate: ""
                              }, null, 8, ["name", "subtitle", "avatar-url", "nps-score"])
                            ]),
                            (_openBlock(), _createElementBlock("svg", _hoisted_21, [
                              _createElementVNode("path", {
                                d: _unref(mdiArrowRight),
                                fill: "currentColor"
                              }, null, 8, _hoisted_22)
                            ])),
                            _createElementVNode("div", _hoisted_23, [
                              receiver
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_24,
                                    _createVNode(DoctorInfo, {
                                      name: receiver.name,
                                      subtitle: `CRM ${receiver.crm}`,
                                      "avatar-url": receiver.avatarUrl,
                                      "nps-score": receiver.npsScore,
                                      size: "sm",
                                      truncate: ""
                                    }, null, 8, ["name", "subtitle", "avatar-url", "nps-score"])
                                  ], 64))
                                : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(emptyReceiverLabel), 1))
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(item.package.schedule.name), 1)
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("span", _hoisted_30, _toDisplayString(getHealthUnitNames(item)[0] ?? '-'), 1),
                            (getHealthUnitNames(item).length > 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, " +" + _toDisplayString(getHealthUnitNames(item).length - 1) + " unidade" + _toDisplayString(getHealthUnitNames(item).length > 2 ? 's' : ''), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(item.totalInQueue), 1)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("span", _hoisted_35, _toDisplayString(formatDate(item.package.createdAt)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_36, [
                          _createElementVNode("span", _hoisted_37, _toDisplayString(item.package.stations.length), 1)
                        ]),
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(item.reviewerName ? _unref(getFirstAndSecondName)(item.reviewerName) : '-'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(HandoverStatusBadge, {
                              status: item.package.status
                            }, null, 8, ["status"])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_42, [
                          _createVNode(OutlineButton, {
                            text: "Detalhes",
                            width: "auto",
                            height: "revert-layer",
                            "data-testid": "history-detail-button",
                            onClick: ($event: any) => (handleDetail(item))
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_43, " Nenhum histórico encontrado ")),
        (!_unref(isLoadingHistory) && _unref(history).length > 0 && _unref(historyMeta).totalPages > 1)
          ? (_openBlock(), _createBlock(_component_v_pagination, {
              key: 3,
              "model-value": _unref(historyMeta).page,
              "total-visible": 5,
              length: _unref(historyMeta).totalPages,
              density: "comfortable",
              color: "primary",
              class: "mt-4",
              "data-testid": "history-pagination",
              "onUpdate:modelValue": handleChangePage
            }, null, 8, ["model-value", "length"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modal-active"]),
    _createVNode(HandoverHistoryDetailModal, {
      modelValue: showDetailModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDetailModal).value = $event)),
      item: selectedItem.value
    }, null, 8, ["modelValue", "item"])
  ], 64))
}
}

})